import { useContext } from 'react';
import ConfigContext from '../contexts/ConfigContext';
import DataContext from '../contexts/DataContext';

import { SunnyBotMessage } from '../data/sunnyBotMessages';

import botImage from './../images/sunny-bot.svg';

export default function SunnyBot({
  data,
}: {
  data: SunnyBotMessage | undefined;
}) {
  const { isDebrandedVersion } = useContext(ConfigContext);
  const { selectedCity } = useContext(DataContext).data;

  if (!data) return null;

  const message = data.message?.replace('{city}', selectedCity);

  return (
    <div className="mb-2 mt-[-20px] md:mt-[-26px]">
      <div
        className={`flex justify-center w-[90px] h-[90px] md:w-[140px] md:h-[140px] short:w-[90px] short:h-[90px] m-auto rounded-full mt-[-75px] short:mt-[-75px] md:mt-[-140px] border-white border-2 md:border-[3px] ${
          isDebrandedVersion ? 'bg-[#5ecf7f]' : 'bg-enph-orange'
        }`}>
        <img
          src={botImage}
          alt=""
          className="w-[55px] md:w-[90px] short:w-[55px]"
        />
      </div>

      {data.titleDesktop && (
        <p className="hidden md:block text-center mt-2 font-bold md:font-normal text-[16px] md:text-[32px]">
          {data.titleDesktop}
        </p>
      )}

      {data.titleMobile && (
        <p className="md:hidden text-center mt-2 font-bold md:font-normal text-[16px] md:text-[32px]">
          {data.titleMobile}
        </p>
      )}

      {message && (
        <p
          className={`hidden md:block text-center md:text-[20px] max-w-[540px] mx-auto ${
            !data.titleDesktop
              ? 'mt-4 md:mt-8 font-bold md:font-normal text-[16px]'
              : 'mt-1 md:mt-0 text-[14px]'
          }`}>
          {message}
        </p>
      )}

      <p
        className={`md:hidden text-center md:text-[20px] ${
          !data.titleMobile
            ? 'mt-4 md:mt-8 font-bold md:font-normal text-[16px]'
            : 'mt-1 md:mt-0 text-[14px]'
        }`}>
        {message}
      </p>
    </div>
  );
}

export function SunnyBotBackground() {
  return (
    <div className="px-6 md:px-0 bg-white h-[115px] top-[40px] md:h-[600px] short:h-[360px] w-full absolute left-0 md:top-0 -z-10">
      <div className='bg-[url("./images/back_sunny_bot.jpg")] bg-cover bg-center h-full w-full rounded-[6px] md:rounded-none'></div>
    </div>
  );
}
